
export default class LoadCast {
	constructor(el) {

		this.castList 		= el.querySelector('.block-cast__members')
		this.cast			= [...el.querySelectorAll('.member')]
		this.dataNum 		= this.castList.dataset.num
		this.loadMoreButton = el.querySelector('.btn')
		this.loadMore 		= this.loadMore.bind(this)

		if(this.dataNum){
			if(this.cast.length > this.dataNum) {
				this.cast.slice(this.dataNum).forEach((member)=> {
					member.style.display = 'none';
				})
			}
		}
	
		this.loadMoreButton && this.loadMoreButton.addEventListener('click', () => {
			this.loadMore();
		})


	}
  
	loadMore() {

		this.dataNum = parseInt(this.dataNum) + 8;
		// console.log(this.dataNum)

		let castSelection = this.cast.slice(0, this.dataNum);
		// console.log(castSelection)

		castSelection.forEach((member)=> {
			member.style.display = 'block';
		})

		if(this.dataNum >= this.cast.length) {
			this.loadMoreButton.style.display = 'none';
		}

	}
  
}